import React from "react";
import { Link } from "react-router-dom";
import Spinner from "Components/RequestHandler/Spinner";
const MainButton = ({
  children,
  to,
  onClick,
  isLoading,
  isBlack,
  isSmall,
  isOutline,
}) => {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={`${
        isOutline
          ? "border border-primary text-primary"
          : isBlack
          ? "bg-dark hover:bg-darkDarker text-white"
          : "bg-primary hover:bg-primaryDark text-white"
      } ${
        isSmall ? "px-4 py-1.5" : "px-10 py-2.5"
      }  rounded-md text flex items-center  justify-center gap-2 w-max`}
    >
      {isLoading ? <Spinner /> : children}
    </Link>
  );
};

export default MainButton;
